import { ClosedDay } from "../../../models";

export const getClosedDay = (data: any): ClosedDay => ({
  id: data.id,
  date: data.attributes.date,
  reason: data.attributes.reason || "",
});

export const getClosedDays = (data: any): ClosedDay[] => data.map(getClosedDay);
